import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />;
});

interface FullScreenDialogProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  onClear?: () => void;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  dialogHeight?: string;
}

const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
  open,
  onClose,
  title,
  onClear,
  children,
  actions,
  dialogHeight,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
      sx={{
        '& .MuiPaper-root': {
          height: dialogHeight || 'auto',
          width: '100%',
          position: 'fixed',
          bottom: 0,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
        },
      }}
    >
      <Box sx={{ width: '1200px', marginTop: '60px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              width: '80px',
              height: '5px',
              borderRadius: '100px 0px 0px 0px',
              backgroundColor: '#00000026',
            }}
          />
        </Box>

        <DialogTitle sx={{ padding: 0, marginBottom: '15px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            {title}
            {onClear && (
              <Button onClick={onClear}>
                LIMPAR
              </Button>
            )}
          </Box>
        </DialogTitle>

        <DialogContent sx={{ padding: 0 }}>{children}</DialogContent>

        <DialogActions sx={{ justifyContent: 'flex-start', padding: 0 }}>{actions}</DialogActions>
      </Box>
    </Dialog>
  );
};

export default FullScreenDialog;
